var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collection"},_vm._l((_vm.list),function(item){return _c('RefiningItem',_vm._b({key:item.id},'RefiningItem',item,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }